import type { AddDocumentDialogProps } from './AddDocumentDialogContent';
import { useDialog } from '@ianesthesie-kit/redux';
import { useCallback } from 'react';
import { AppDialogType } from '@/config';

export const useAddDocumentDialog = () => {
  const { showDialog } = useDialog();

  return useCallback(
    (dialogProps?: AddDocumentDialogProps) => {
      showDialog({
        dialogType: AppDialogType.ADD_DOCUMENT,
        message: '',
        ...(dialogProps as any) // TODO fix types
      });
    },
    [showDialog]
  );
};
